import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './AloWidgetComponent.scss';

class AloWidgetComponent extends React.Component {
    render() {
        const { widgetUrl } = this.props;
        return (
            <div id="oxlin-embed" className="oxlin-widget">
                <iframe width="1024" height="600" src={widgetUrl} frameBorder="0" title="Oxlin" />
            </div>
        );
    }
}

AloWidgetComponent.propTypes = {
    widgetUrl: PropTypes.string
};

export default connect()(AloWidgetComponent);



// WEBPACK FOOTER //
// ./src/components/alo/AloWidgetComponent.js